import Lottie from 'lottie-react';
import {
  FlexBox,
  ScrollXBox,
  FloatingBox,
  SideBox,
  BannerBox,
  VisualBox,
  FooterSpace,
  FloatinArea,
  DefaultBox,
  SegmentBox,
} from '../etc/LBox/LBox';
import Observer from '../etc/Observer/Observer';
import Table from '../etc/Table/Table';
import Rolling from '../component/Rolling/Rolling';
import InfoCard from '../etc/InfoCard/InfoCard';
import { UnderLineText } from '../typography/Typography.styled';

import useLanding from '../../application/bloc/useLanding';
import useFooter from '../../application/hooks/useFooter';

import {
  Button,
  Spacer,
  SimpleItem,
  Divider,
  HeadTitle,
  Card,
  TheFooter,
  SpacerSection,
  Tbd28,
  Tmd14,
} from 'oui';

import rate from '../../assets/gif/rate.gif';
import amount from '../../assets/gif/amount.gif';
import rate_thumbnail from '../../assets/gif/rate_thumbnail.png';
import amount_thumbnail from '../../assets/gif/amount_thumbnail.png';
import main_credit from '../../assets/gif/credit.gif';
import main_partners from '../../assets/gif/partners.gif';
import loanNumberCount from '../../assets/gif/loan_number_count.gif';
import rateNumberCount from '../../assets/gif/rate_number_count.gif';
import { PAGE_NM } from '../../application/types/types';
import logoAnimation from '../../assets/lottie/logo_animation.json';
import { ClkBtnSubEventNm } from '../../application/hooks/useBeacon';

const Landing = () => {
  const {
    navigateOvertake,
    navigateOvertakePrivacy,
    navigateOnlineLoanCorp,
    navigateTestPage,
  } = useFooter();

  const {
    hasBannerList,
    bannerList,

    navigateTo,
    navigateCreditMain,
    navigateCreditOrMyDataByAppversion,
    navigatePartners,
    navigateBannerToPage,
    navigateStatus,

    sendBeaconClkBtnLoanApp,
    sendBeaconClkBtnBnkList,
    sendBeaconClkBtnNotiSchAlrt,
    sendBeaconClkBtnIntrstCalc,
    sendBeaconClkBtnLoanPrg,

    isLazy,
    isTodayRequested,
    isFloating,
    setIsFloating,
    hasLoanStatus,

    simpleList,
    cardList,

    media,
    terms,
    isRedirect,
  } = useLanding(PAGE_NM.HOME);

  const handleClickMainButton = (e?: any) => {
    sendBeaconClkBtnLoanApp(e.target.innerHTML || '');
    if (isTodayRequested) {
      navigateCreditMain();
    } else {
      terms.showTerm();
    }
  };

  const handleClickCreditButton = () => {
    navigateCreditOrMyDataByAppversion && navigateCreditOrMyDataByAppversion();
  };

  const handleClickPartnersButton = (e: any) => {
    sendBeaconClkBtnBnkList(e.target.innerText || '');
    navigatePartners();
  };
  const handleClickSimpleList = (item: any) => {
    if (item && item.navigate) {
      navigateTo({
        destination: item.navigate.destination,
        refPage: PAGE_NM.HOME,
        refBtnNm: item?.beacon?.buttonName ?? '',
      });
    }
    // navigate: {
    //   destination: '/mtg/result-status',
    // },
    // if (hasLoanStatus) {
    //   if (idx === 0) {
    //     handleClickLoanStatus();
    //   } else {
    //     navigateBannerToPage(idx - 1);
    //     if (idx === 1) {
    //       sendBeaconClkBtnNotiSchAlrt('정기 알림');
    //     } else if (idx === 2) {
    //       sendBeaconClkBtnIntrstCalc('이자 계산기');
    //     }
    //   }
    // } else {
    //   navigateBannerToPage(idx);
    //   if (idx === 0) {
    //     sendBeaconClkBtnNotiSchAlrt('정기 알림');
    //   } else if (idx === 1) {
    //     sendBeaconClkBtnIntrstCalc('이자 계산기');
    //   }
    // }
  };
  const handleClickLoanStatus = () => {
    navigateStatus();
    sendBeaconClkBtnLoanPrg('대출 진행 현황');
  };

  const ctaButton = (
    <Button
      configuration={'contained'}
      flexible={true}
      onClick={(e: any) => handleClickMainButton(e)}
    >
      {isTodayRequested ? '비교 결과 보러 가기' : '1분 안에 최저금리 찾기'}
    </Button>
  );

  if (isRedirect) return null;

  return (
    <>
      <>
        <SpacerSection
          size={'md'}
          children={
            <>
              <DefaultBox>
                <Tbd28 text="빠르고 쉽게" />
                <br />
                <Tbd28 text="대출 비교해 보세요!" />
              </DefaultBox>
              <Lottie animationData={logoAnimation} />
              <DefaultBox>
                <SegmentBox gap={8}>
                  <InfoCard>
                    <Tmd14 text="최저 금리" />
                    <img src={rateNumberCount} alt="최저 금리" width="100%" />
                  </InfoCard>
                  <InfoCard>
                    <Tmd14 text="최고 한도" />
                    <img src={loanNumberCount} alt="최고 한도" width="100%" />
                  </InfoCard>
                </SegmentBox>
              </DefaultBox>
              <SideBox>
                <Observer handleState={(e: any) => setIsFloating(e)}>
                  {ctaButton}
                </Observer>
              </SideBox>
            </>
          }
        />

        <FloatinArea>
          <SideBox>
            <Spacer size={'sm'} />
            {simpleList.map((item: any, idx: number) => {
              return (
                <div key={idx + item.subheaderText}>
                  <SimpleItem
                    key={idx + item.subheaderText}
                    state={item.avatar.state}
                    avatar={item.avatar}
                    headerText={item.headerText}
                    subheaderText={item.subheaderText}
                    stateChip={item.chip}
                    stress={false}
                    onClickSimpleItem={() => handleClickSimpleList(item)}
                  />
                  {idx < simpleList.length - 1 && <Spacer size={'sm'} />}
                </div>
              );
            })}
            <Spacer size={'sm'} />
          </SideBox>

          {hasBannerList && (
            <BannerBox>
              <Rolling
                items={bannerList}
                onClickItem={(idx) => {
                  bannerList[idx].navigate();
                  bannerList[idx].beacon.click();
                }}
                onChangeItem={(idx) => {
                  bannerList[idx].beacon.view();
                }}
              />
            </BannerBox>
          )}

          <Divider type={'contents'} />
          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle
                  textTitle={'여러 번 조회해도\n 신용점수에 영향이 없어요'}
                />
                <VisualBox>
                  <img src={main_credit} alt={'main-credit'} />
                </VisualBox>
                {media === 'kt' && (
                  <UnderLineText onClick={handleClickCreditButton}>
                    나의 신용점수 보러 가기
                  </UnderLineText>
                )}
              </>
            }
          />
          <Divider type={'contents'} />
          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle
                  textTitle={'다양한 금융사를\n 한 곳에서 비교할 수 있어요'}
                />
                <VisualBox>
                  <img src={main_partners} alt={'main-partners'} />
                </VisualBox>
                <UnderLineText onClick={handleClickPartnersButton}>
                  함께하는 금융사
                </UnderLineText>
              </>
            }
          />
          <Divider type={'contents'} />
          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle
                  textTitle={'다양한 금융 서비스도\n 함께 경험해 보세요'}
                />
                <ScrollXBox>
                  {cardList.map((item: any, idx: number) => (
                    <Card
                      key={idx + item.secondaryText + item.primaryText}
                      avatar={item.avatar}
                      text={item.primaryText}
                      subText={item.secondaryText}
                      onClickCard={() => {
                        cardList[idx].beacon();
                        cardList[idx].navigate();
                      }}
                    />
                  ))}
                </ScrollXBox>
              </>
            }
          />
          <TheFooter
            type={'a'}
            onClickOnlineLoanCorp={navigateOnlineLoanCorp}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
            onClickTest={navigateTestPage}
            media={media}
          />
          <FloatingBox status={isFloating}>{ctaButton}</FloatingBox>
        </FloatinArea>
        <FooterSpace />
      </>
    </>
  );
};

export default Landing;
